(() => {
  const initializeSavageStickyCart = () => {
    const button = document.querySelector('sticky-atc-bar-minimalist [name="add"]');
    if (!button || document.documentElement.dataset.savageStickyCartBound === 'true') return;

    const updateStickyVisibility = () => {
      const stickyBar = document.querySelector('sticky-atc-bar-minimalist');
      const mainProductForm = document.querySelector('.main-product-form');
      if (!stickyBar || !mainProductForm) return;
      stickyBar.classList.toggle('sticky-atc-bar--show', mainProductForm.getBoundingClientRect().bottom < 0);
    };

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    updateStickyVisibility();

    document.documentElement.dataset.savageStickyCartBound = 'true';
    document.addEventListener('click', (event) => {
      const button = event.target.closest('sticky-atc-bar-minimalist [name="add"]');
      if (!button) return;

      event.preventDefault();
      if (button.disabled) return;

      const mainForm = document.getElementById(button.getAttribute('form'));
      if (!mainForm) return;

      const mainSubmitButton = mainForm.querySelector('[name="add"]');
      if (!mainSubmitButton || mainSubmitButton.disabled) return;

      mainForm.requestSubmit(mainSubmitButton);
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSavageStickyCart, { once: true });
  } else {
    initializeSavageStickyCart();
  }
})();
